// extracted by mini-css-extract-plugin
export default {"no-notification":"no-notification","view-more":"view-more"};
    if(module.hot) {
      // 1790857663359
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  